var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icool-icon',{attrs:{"icon":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }